import CreateAlarm from '@/pages/Integrations/Nextbitt/Create';
import * as React from 'react';
import { createRoot } from 'react-dom/client';

WiseMetering.Views.NewNextbittMaintenanceIntegration = Backbone.Marionette.View.extend({
    id: 'react-container',
    className: 'tailwind-container',

    onShow: function() {
        const license = this.model ? this.model.toJSON() : {};

        this.reactRoot = createRoot(document.getElementById(this.id));
        this.reactRoot.render(<CreateAlarm license={license}/>);
    },

    onClose: function() {
        if (this.reactRoot) {
            this.reactRoot.unmount(); // Unmount the React component
            this.reactRoot = null; // Clean up reference
        }
    }
});
